export const addProxyEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/addproxy?endDate=${
        queryParams.endDate
    }&startDate=${queryParams.startDate}&uid=${queryParams.uid}&proxyForUid=${
        queryParams.proxyForUid
    }`;

export const updateProxyEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/updateProxy?endDate=${
        queryParams.endDate
    }&startDate=${queryParams.startDate}&proxyId=${
        queryParams.proxyId
    }&proxyForUid=${queryParams.proxyForUid}`;

export const getProxyUserListEndpoint = (data) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/getProxyUsers?isOutsideDistrict=${data.isOutsideDistrict}&pageNumber=${data.page}&pageSize=${data.pageSize ? data.pageSize : 100}&searchParam=${data.searchTerm ? data.searchTerm : ''}`;

export const getProxyListEndpoint = () =>
    `/occ/v2/${localStorage.getItem('baseSiteId')}/proxy/proxies`;

export const revokeProxyEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/${queryParams}`;
